export class FetchUnknownError extends Error {
  constructor(public reason: string) {
    super(reason)
  }
}
